import { DiGraph } from "../../graph/digraph.js";

/** Small proof subject: first-response habits (M.4), separate from AI literacy. */
const EDGES: readonly [string, string][] = [
  ["scene_safety", "bleeding_basic"],
  ["scene_safety", "emergency_call"],
  ["bleeding_basic", "recovery_position"],
  ["emergency_call", "recovery_position"],
];

export const FIRST_AID_NODE_IDS: readonly string[] = [
  "scene_safety",
  "bleeding_basic",
  "emergency_call",
  "recovery_position",
];

export function buildFirstAidGraph(): DiGraph {
  const g = new DiGraph();
  for (const [a, b] of EDGES) {
    g.addEdge(a, b, 1);
  }
  for (const id of FIRST_AID_NODE_IDS) {
    g.addNode(id);
  }
  return g;
}
